
export enum FaqFormField {
  id = "id",
  event_id = "event_id",
  question = "question",
  answer = "answer",
  is_active = "is_active",
  question_Arabic = "question_Arabic",
  answer_Arabic = "answer_Arabic",
}

export type FaqFormValues = {
  [FaqFormField.id]: number;
  [FaqFormField.event_id]: number;
  [FaqFormField.question]: string;
  [FaqFormField.answer]: string;
  [FaqFormField.is_active]: boolean;
  [FaqFormField.question_Arabic]: string;
  [FaqFormField.answer_Arabic]: string;
};